import Http from "../Http";
import { INSPECTION_URL } from "../Helper";

export function getComments(req_id) {
  return new Promise((resolve, reject) => {
    Http.get(`${INSPECTION_URL}getcomments/${req_id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function addComment(data) {
  const payload = {
    post_id: data.req_id,
    content: data.comment,
  };
  return new Promise((resolve, reject) => {
    Http.post(`${INSPECTION_URL}comments`, payload)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
